import { createNamespace } from "Common/namespaceUtils/namespaceRedux";
export const NAMESPACE = "rightSideDetailsPanel";
export const FULL_NAMESPACE = createNamespace(NAMESPACE);
export const localStorageSettingsKey = "ohotnik.rightSideDetailsPanel.settings";
